/* Listener
   listener(document, 'add', 'click', ()=>, false)
   ========================================================================== */

export function listener(el, action, type, cb, p) {
  const method = action + "EventListener"
  const passive = p === true ? { passive: true } : false

  // Helper to safely add listener
  const addListener = target => {
    try {
      target[method](type, cb, passive)
    } catch (err) {
      console.warn(`Listener failed on element:`, target, err)
    }
  }

  if (NodeList.prototype.isPrototypeOf(el) || Array.isArray(el)) {
    for (let i = 0; i < el.length; i++) {
      addListener(el[i])
    }
  } else {
    addListener(el)
  }
}
